/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Debt_Fill_HintInputs */

const vi_lot_debt_fill_hint = /** @type {(inputs: Lot_Debt_Fill_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhập kho không phải lúc nào cũng là hàng của đơn đang nợ, nên các ô để trống sẵn. Gõ số vào cột "Bù lần này", hoặc bấm "Bù hết" để bù tối đa cho một đơn.`)
};

/**

* @param {Lot_Debt_Fill_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_debt_fill_hint = /** @type {((inputs?: Lot_Debt_Fill_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Debt_Fill_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_debt_fill_hint(inputs)
});